import React from 'react';
import Head from 'next/head';
import { Container, Row, Col, Nav, NavItem, NavLink } from 'reactstrap';
import Page from '../../components/page';
import {SiteChrome, SiteData} from '../../components/chrome/layout';
import { DirectLink, Element} from 'react-scroll';
import Promise from '../../components/giveAssured/promise';
import WhyGiveassured from '../../components/giveAssured/whyGiveassured';
import DueDiligenceProcess from '../../components/giveAssured/dueDiligenceProcess';
import CriticalCheck from '../../components/giveAssured/criticalCheck';
import DonationReach from '../../components/giveAssured/donationReach';
import GiveassuredImages from '../../components/giveAssured/giveassuredImages';


const dashboardTabs = {
	giveindiapromises: {
		id: 'giveindiapromises',
		name: 'The GiveIndia Promise',
	},
	whyGiveAssured: {
		id: 'whyGiveAssured',
		name: 'Why GiveAssured',
	},
	dueDiligenceProcess: {
		id: 'dueDiligenceProcess',
		name: 'Due Diligence process',
	},
	criticalCheckBeforeListing: {
		id: 'criticalCheckBeforeListing',
		name: 'Critical checks before listing',
	},
  makingsureYourDonation: {
    id: 'makingsureYourDonation',
    name: 'Making sure your donations reach the right people',
  },
  images: {
    id: 'images',
    name: 'Check out photos from our visits',
  },

};
export default class extends Page {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: 'giveindiapromises',
 		 	isOpen: props.isOpen || [dashboardTabs.giveindiapromises],
 		 	position: 0,
 		 	data: props.data || null,
		};
	}

	static async getInitialProps({ req, res }) {
		const props = await super.getInitialProps({ req, res });
		props.pageType = 'giveassured';

		return props;
	}

	handleTabChange = (toTab) => {
		const data = { to: toTab, initialPath: this.state.isOpen };


		this.setState({ activeTab: toTab, isOpen: [dashboardTabs[toTab]] });
	}

	render() {
		const { session } = this.props;
		const { isOpen } = this.state;
		const store = { ... this.props.store };
		return (
			<SiteData store={store}>
			<SiteChrome session={session}>
			<Head>
				<title>Why GiveIndia is India’s most trusted Donation Platform</title>
				<meta name="description" content="GiveAssured is GiveIndia's framework of transparency and accountability to our donors about every donation they make. Get regular reports on impact of your every donation." />
				<link rel="canonical" href={this.props.store.canonicalUrl} />
			</Head>
				<Container className="mobile-p-0">
				<h1 className="headings-giveassured" >Give Assured</h1>
					<Row>
						<Col lg="3" md="4" sm="12" xs="12" className="left-user-column auto-scroll-x webkit-scrolling w-100">
							<Nav vertical className="user-nav no-wrap ">

								<NavItem className="ml-auto dashboard-nav">
									<NavLink
										id="giveindiapromises"
										href="#"
										onClick={() => this.handleTabChange('giveindiapromises')}
										active={isOpen[0].id === 'giveindiapromises'}
										className="user-nav-link"
									>{dashboardTabs.giveindiapromises.name}
									</NavLink>
								</NavItem>
								<NavItem className="ml-auto dashboard-nav">
									<NavLink
										id="whyGiveAssured"
										href="#"
										onClick={() => this.handleTabChange('whyGiveAssured')}
										active={isOpen[0].id === 'whyGiveAssured'}
										className="user-nav-link"
									>{dashboardTabs.whyGiveAssured.name}
									</NavLink>
								</NavItem>
								<NavItem className="ml-auto dashboard-nav">
									<NavLink
										id="dueDiligenceProcess"
										href="#"
										onClick={() => this.handleTabChange('dueDiligenceProcess')}
										active={isOpen[0].id === 'dueDiligenceProcess'}
										className="user-nav-link"
									>{dashboardTabs.dueDiligenceProcess.name}
									</NavLink>
								</NavItem>
								<NavItem className="ml-auto dashboard-nav">
									<NavLink
										id="criticalCheckBeforeListing"
										href="#"
										onClick={() => this.handleTabChange('criticalCheckBeforeListing')}
										active={isOpen[0].id === 'criticalCheckBeforeListing'}
										className="user-nav-link"
									>{dashboardTabs.criticalCheckBeforeListing.name}
									</NavLink>
								</NavItem>
								<NavItem className="ml-auto dashboard-nav">
									<NavLink
										id="makingsureYourDonation"
										href="#"
										onClick={() => this.handleTabChange('makingsureYourDonation')}
										active={isOpen[0].id === 'makingsureYourDonation'}
										className="user-nav-link"
									>{dashboardTabs.makingsureYourDonation.name}
									</NavLink>
								</NavItem>
								<NavItem className="ml-auto dashboard-nav">
									<NavLink
										id="images"
										href="#"
										onClick={() => this.handleTabChange('images')}
										active={isOpen[0].id === 'images'}
										className="user-nav-link"
									>{dashboardTabs.images.name}
									</NavLink>
								</NavItem>


							</Nav>
						</Col>
						<Col lg="9" md="8" sm="12" xs="12">
							<Element name="user-dashboard-panel">
								{getActivePanel(isOpen)}
							</Element>
						</Col>

					</Row>
				</Container>

			</SiteChrome>
			</SiteData>
		);
	}
}


const getActivePanel = (isOpen) => {
	if (typeof isOpen === 'undefined' || isOpen.length === 1 || (isOpen.length === 2 && isOpen[1].name.includes('_'))) {
		switch (isOpen[0].id) {
		case 'giveindiapromises':
			return (<Row> <Promise /> </Row>);
		case 'whyGiveAssured':
			return (<Row> <WhyGiveassured /> </Row>);
		case 'dueDiligenceProcess':
			return (<Row> <DueDiligenceProcess /> </Row>);
		case 'criticalCheckBeforeListing':
			return (<Row> <CriticalCheck /> </Row>);
		case 'makingsureYourDonation':
			return (<Row> <DonationReach /> </Row>);
		case 'images':
			return (<Row> <GiveassuredImages /> </Row>);

		default:
			return null;
		}
	}
};
